import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";

import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";
import { itemRouteBuilder, NamedRts } from "@/router";
import { ClientField } from "@/store/modules/clientFields";
import { genericSort, sortIcon } from "@/components/helpers";
import { filter as Rfilter } from "ramda";

export default defineComponent({
  name: "clientFields",
  components: {
    LoadingAnimation,
  },

  setup(_props, ctx) {
    let $store = ctx.root.$store;

    let dataLoaded = ref(false);
    let loadingMessage = ref("Loading Fields...");

    let filter = ref("");

    let sortKey = ref<"name" | "client_name" | "acres">("name");
    let sortAsc = ref(true);

    const apiClientFields = computed(() => {
      return $store.getters.clientFields as ClientField[];
    });

    const localClientFields = ref<ClientField[]>([]);

    const showRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.clientFieldShow, id);
    };

    const editRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.clientFieldEditForm, id);
    };

    const clientFields = computed(() => {
      let tmpResults = [...localClientFields.value];

      if (filter.value !== "") {
        let tmpReg = new RegExp(filter.value, "i");
        tmpResults = Rfilter((item: any) => {
          let nameResult = tmpReg.test(item.name);
          let clientNameResult = tmpReg.test(item.client_name);

          return nameResult || clientNameResult;
        }, tmpResults);
      }

      return tmpResults;
    });

    const localSortIcon = (lSortKey: "name" | "client_name" | "acres") => {
      return sortIcon(sortAsc, sortKey, lSortKey);
    };

    const getClientFields = () => {
      dataLoaded.value = false;
      const jsConn = new JSConn();
      $store.dispatch("needClientFields", jsConn).then(() => {
        localClientFields.value = [...apiClientFields.value];
        // flip the sort, otherwise on load it would be off
        sortAsc.value = !sortAsc.value;
        updateSort(sortKey.value);
        dataLoaded.value = true;
        return Promise.resolve();
      });
    };

    const updateSort = (lSortKey: "name" | "client_name" | "acres") => {
      localClientFields.value = genericSort(
        [...localClientFields.value],
        sortAsc,
        sortKey,
        lSortKey,
      );
    };

    onMounted(() => {
      getClientFields();
    });

    return {
      dataLoaded,
      loadingMessage,

      clientFields,

      filter,

      updateSort,
      localSortIcon,

      showRouteBuilder,
      editRouteBuilder,
    };
  },
});
